import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow, IconButton } from '@mui/material'
// import { Delete, Edit, Add, IsActive } from '../../../../../assets/img/icons'
import { Delete, Edit, Close } from '../../../../../assets/img/icons'
import questionService from '../../../../../services/questionManagement.service'
import { LoaderDots, Confirmation } from '../../../../../components'
import { useGlobalStore } from '../../../../../store'
import { consoleLog, getObjectAsArray, sortGridBy } from '../../../../../util'
import EditComponent from '../edit'
import { GridWrapper, TableWrapper } from './style'

const Grid = ({ refreshData, settings }) => {
  const [gridData, setGridData] = useState([])
  const [loader, setLoader] = useState(true)
  const [deleteObject, setDeleteObject] = useState(null)
  const [editObject, setEditObject] = useState(null)
  const [sortedBy, setSortedBy] = useState('ItemCount')
  const [confirmationLoading, setConfirmationLoading] = useState(false)
  const { company } = useGlobalStore()

  const isNotSubQuestion = () => {
    const data = !([
      'itemSubQuestion1A', 'itemSubQuestion1B', 'itemSubQuestion3A', 'itemSubQuestion3B',
      'userLocalSubQuestion1A', 'userLocalSubQuestion1B', 'userLocalSubQuestion3A', 'userLocalSubQuestion3B'
    ].includes(settings.type))
    return data
  }

  const onload = async () => {
    try {
      setLoader(true)
      const payload = { organizationId: company?.OrganizationId }
      const responseWithoutCount = await questionService.getOrganizationAggregationQuestionApi(payload, settings.type)
      const responseWithCount = await questionService.getItemsAnalyzedPerQuestionCountApi(payload, settings.type)

      const responseWithoutCountArray = getObjectAsArray(responseWithoutCount, 'adv').map(d => ({ QuestionValue: d, ItemCount: '', active: true, edit: false }))
      const responseWithCountArray = getObjectAsArray(responseWithCount, 'adv').map(d => ({ ...d, active: false, edit: false }))

      const mergedArray = responseWithCountArray.concat(responseWithoutCountArray.filter(
        item2 => !responseWithCountArray.some(item1 => item1.QuestionValue === item2.QuestionValue)))

      if (isNotSubQuestion()) {
        setGridData(mergedArray)
      } else {
        setGridData(responseWithoutCountArray)
      }
      setLoader(false)
    } catch (err) {
      consoleLog('err - ', err)
    }
  }

  const deleteFunc = async () => {
    setConfirmationLoading(true)
    const payload = { organizationId: company?.OrganizationId, [settings.keyValue]: deleteObject.QuestionValue, delete: true }

    questionService.setOrganizationAggregationQuestionApi(payload, settings.type)
      .then((resp) => {
        // consoleLog('Delete row > resp - ', resp)
      })
      .catch((error) => {
        consoleLog('ERROR - ', error)
      })
      .finally(() => {
        setTimeout(() => {
          setConfirmationLoading(false)
          setDeleteObject(null)
          onload()
        }, 1000)
      })
  }

  const setEditFunc = async (obj) => {
    const gridDataNew = gridData.map(d => ({ ...d, edit: obj.QuestionValue === d?.QuestionValue ? !obj?.edit : false }))
    setGridData(gridDataNew)
    setEditObject(obj)
  }

  useEffect(() => {
    onload()
  }, [refreshData])

  // useEffect(() => {
  //   consoleLog('editObject = ', editObject)
  // }, [editObject])

  useEffect(() => {
    onload()
  }, [company?.OrganizationId, settings?.type])

  useEffect(() => {
    setGridData([...sortGridBy(gridData, sortedBy)])
  }, [sortedBy])

  // useEffect(() => {
  //   setGridData([...sortGridBy(gridData, 'ItemCount')])
  // }, [])

  return (
    <GridWrapper>
      <TableWrapper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          {gridData && gridData?.length > 0 && <Table aria-labelledby='tableTitle' size='medium'>
            <TableHead>
              <TableRow>
                <TableCell onClick={() => setSortedBy('QuestionValue')}>{settings.title} Options</TableCell>
                <TableCell onClick={() => setSortedBy('ItemCount')}>Count</TableCell>
                {/* <TableCell>sortedBy = {sortedBy}</TableCell> */}
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!loader && gridData?.sort((a, b) => b.ItemCount - a.ItemCount).map((row, index) => {
              // {gridData?.map((row, index) => {
                return (
                  <React.Fragment key={index}>
                    <TableRow className={row?.edit ? 'active' : ''}>
                      <TableCell>{row.QuestionValue}</TableCell>
                      <TableCell style={{ width: '100px' }}>{row.ItemCount}</TableCell>
                      <TableCell className='actionWrapper'>
                        {settings.edit && !row?.edit && <IconButton className='btnEdit' onClick={() => setEditFunc(row)}><Edit type='editIcon' /></IconButton>}
                        {settings.edit && row?.edit && <IconButton className='btnClose' onClick={() => setEditFunc(row)}><Close /></IconButton>}
                        <IconButton className='btnDelete' onClick={() => setDeleteObject(row)}><Delete /></IconButton>
                      </TableCell>
                    </TableRow>
                    {row.edit && <TableRow className='editSection'>
                      <TableCell colSpan='3'><EditComponent rowData={row} editSettings={settings} onChange={() => setEditFunc(editObject)} /></TableCell>
                    </TableRow>}
                  </React.Fragment>
                )
              })}
            </TableBody>
          </Table>}

          {deleteObject && <Confirmation
            open={true}
            title={`Are you sure you want to delete this row(${deleteObject.QuestionValue})?`}
            onClose={() => setDeleteObject(null)}
            onCancel={() => setDeleteObject(null)}
            onSubmit={() => deleteFunc()}
            loading={confirmationLoading}
          />}

          {/* {addObject && <Confirmation
            open={true}
            title={`Are you sure you want to add this row(${addObject.QuestionValue})?`}
            onClose={() => setAddObject(null)}
            onCancel={() => setAddObject(null)}
            onSubmit={() => addFunc()}
            loading={confirmationLoading}
          />} */}

          {/* {activeObject && <Confirmation
            open={true}
            title={`Are you sure you want to ${activeObject.IsActive ? 'Deactivate' : 'Activate'} this item?`}
            onClose={() => setActiveObject(null)}
            onCancel={() => setActiveObject(null)}
            onSubmit={() => activeFunc(activeObject)}
          />} */}

          {loader && <LoaderDots /> }
          {!loader && gridData?.length === 0 && (
            <Table>
              <TableRow>
                <TableCell>
                  No Data Found
                </TableCell>
              </TableRow>
            </Table>
          )}
        </TableContainer>
      </TableWrapper>
    </GridWrapper>
  )
}

Grid.propTypes = {
  refreshData: PropTypes.number,
  settings: PropTypes.object
}

export default Grid
